// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"141":"199e86747224aba4","191":"ef1be0b8ba57b5ed","724":"3abc1dc0a9f3727f","726":"b5f2a32c353c6f1d"}[chunkId] + ".js";
};